
import SelectList from 'react-widgets/lib/SelectList'


/*

import asyncValidate from './asyncValidate'
import {loadAddressDataDB as loadAccount } from '../../redux/svractions/svreviewActions'
*/
import {loadAddressData as loadAccount } from '../../redux/svractions/svreviewActions'

import { reduxForm , handleSubmit, FieldArray,Field, startSubmit, formValueSelector} from 'redux-form'

//import { loadPdAction, loadPdMyReservatiionsAddressAction} from '../../actions'
import {SVPDFORM,SV_SERVICES, SV_SERVER_ADDRESS, SV_URL} from '../../constants'
import {SV_SOJ_ORCMOCK_ADDRESS} from '../../constants'
import { Radio } from 'antd'

///Users/sam_b2/Downloads/tm/svctest/frontend-quiz/app/css/svdreact.css
//import 'style-loader!../../css/svdreact.css'
import {  Link } from "react-router-dom"
import '../../css/svformwerror.css'
const React = require('react')
const _ = require('lodash')
const {connect}  = require("react-redux")


const svChange = (values, dispatch, props, valuesPrev)=>{

    console.log('sv form change')
  
    console.log(values)
  
  
  }
const svNotifySavePromise=(
    values
)=>{
            let url= `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
            let data = {
                "id": "addLeft_step"

            }
            data = values
            //data =transformToBA(values)
            let postRq={
                method:'POST',
                headers:{
                    Accept:'application/json',
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(data) 
            }


            return fetch(url, postRq).then((rs)=>{
                console.log('sv got rs promise')
                return rs.json()
            }).catch((e)=>{
                return new Promise.resolve(e)
            })
}

const svsubmit =(values)=>{
    let me = this
  console.log('sv submit callback')
  console.log(values)
/*

  Promise.all([svNotifySavePromise(values)]).then((ar)=>{
      console.log('sv got promise data')

      let rs= ar[0]
      console.log(rs)
        if(rs.data.value.payload.gene){
           // me.props.geneReceptorActivate(rs.data.value.payload.gene, rs.data.value.payload)
        }
   

  })
  */
  //this.props.handleSubmit(this.props.submit('SVClassifierForm'))
}

const renderField = ({
    input,
    label,
    type,
    meta: { asyncValidating, touched, error }
  }) => (
    
     
      
      <div className={asyncValidating ? 'async-validating' : ''}>
          
        <input className="form-control" {...input} type={type} placeholder={label} />
        {touched && error && <span className="sv-form-err" >{error}</span>}
      </div>
   
  )
  const renderFieldDup = ({
    input,
    label,
    type,
    meta: { asyncValidating, touched, error }
  }) => (
    
     
      
      <div className={asyncValidating ? 'async-validating' : ''}>
          {touched && error &&  <input className="sverr form-control" {...input} type={type} placeholder={label} /> }
          {touched && !error &&  <input className="svgreen form-control" {...input} type={type} placeholder={label} /> }
        <input className="form-control" {...input} type={type} placeholder={label} />
        {touched && error && <span className="sv-form-err" >{error}</span>}
      </div>
   
  )
  
const renderSelectList = ({ input, data }) => (
    <SelectList {...input} onBlur={() => input.onBlur()} data={data} />
  )
  const renderTravelSelectList = ({ input, data }) => (
    <SelectList {...input} onBlur={() => input.onBlur()} data={data} />
  )

  const renderBookingAgentType = ({input, data})=> (
      <SelectList {...input } onBlur={() =>input.onBlur()} data={data} />
  )
  
let dcountries = [{
    name:'United States Of America',
    value:'usa'

  },{
    name:'France',
    value:'France'
  },{

    name:'China',
    value:'China'
},{
    name:'Mexico',
    value:'Mexico'
  
  }]

let genes = [{
    name:'add_step',
    value:'add_step'

  },{
    name:'multiply_seq_step',
    value:'multiply_seq_step'
  },{

    name:'sq_step',
    value:'sq_step'
},{
    name:'sr_step',
    value:'sr_step'
  
  }]

  
  let validate =(formData)=>{
    console.log('sv--valudare fprmData')
      console.log(validate)
        const errors={}
        if(!formData){
            console.log('validate: sv formData null issue')
            console.log(errors)
            return errors
        }
        if(!formData.fname){
            errors.fname= 'Required'
        }
        if(!formData.lname){
            errors.lname= 'Required'
        }
        if(!formData.email){
            errors.email= 'Required'
        }
        if(!formData.address){
            errors.address= 'Required'
        }
        if(!formData.city){
            errors.city= 'Required'
        }
        if(!formData.zip){
            errors.zip= 'Required'
        }
       /*
        if(!formData.country){
            errors.country= 'Required'
        }
        if(!formData.phone){
            errors.phone= 'Required'
        }
        */
        /*sva
        if(!formData.card){
            errors.card= 'Required'
        }
        if(!formData.cvv){
            errors.cvv= 'Required'
        }
        if(!formData.mmexp){
            errors.mmexp= 'Required'
        }
        if(!formData.yyyyexp){
            errors.yyyyexp= 'Required'
        }
        if(!formData.country){
            errors.country= 'Required'
        }
        */
        return errors
    
    }
    
    let warn= (formData)=>{
        const o = {}
        if(!formData){
            console.log('sv gene null issue')
            return o
        }
        /*
        if(formData.lname <2){
            o.gene ='We expect gene to br more tham 5'
        }
        */
        return o
    }

    const data = {
        "id": 6,
        "addressId": 6,
        "customerId": 6,
        "name": "alen beta",
        "fname": "alen",
        "lname": "beta",
        "phone": "5121231234",
        "email": "alen11@br.com",
        "login": "alenb",
        "password": null,
        "otherDetails": "need pickup",
        "city": "san jose",
        "state": "ca",
        "country": "usa",
        "address": null,
        "zip": "95123",
        "isdcode": "3",
        "addressType": "B",
        "createdDate": null,
        "modifiedDate": null,
        "createdBy": null,
        "modifiedBy": null
    }

class PaymentDetailFormBus extends React.Component{
    

    constructor(props){
        super(props)
       
        this.loadGene = this.loadGene.bind(this)
        this.ddChange = this.ddChange.bind(this) 
        /*
        this.getAppDetails = this.getAppDetails.bind(this)
        */
        this.dcountryChange = this.dcountryChange.bind(this)
    }
    componentWillMount()	{
        console.log('sv--call PaymentData  should needs addressid action load to gtethe formvalues pdForm')
        const { custProfile, my_data_address, my_data_card} = this.props
         console.log('sv-- PaymentDetail  PaymentData custProfile  from SVWizard+')
      
        console.log(custProfile)
        console.log(my_data_address)
         console.log('sv--PaymentDetail dcustProfile from  SVWizrd end')
         if( my_data_address && (my_data_address.email.length > 0)){
            console.log('sv--PaymentDetail dcustProfile from  SVWizrd calls load ')
            console.log(my_data_address)
            this.props.load(my_data_address)
         }
         /*
         if( custProfile && (custProfile.customerId > 0)){
            this.props.load(custProfile)
         }
         */
         /*
        const data = {
            "addressId": 6,
            "customerId": 6,
            "name": "alen beta",
            "fname": "alen",
            "lname": "beta",
            "phone": "5121231234",
            "email": "alen11@br.com",
            "login": "alenb",
            "password": null,
            "otherDetails": "need pickup",
            "city": "san jose",
            "state": "ca",
            "country": "usa",
            "address": null,
            "zipcode": "95123",
            "isdcode": "1",
            "addressType": "B",
            "createdDate": null,
            "modifiedDate": null,
            "createdBy": null,
            "modifiedBy": null
        }
       this.props.load(data)
       */
        
    console.log('sbv--sjourn id ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:')
    
    
      
   
			
			
	

	}
    /*
    

  
    getAppDetails(paramQSpaceId){
        // Previou step of wizard has alrady put the state  in Review get from thatfrom props and pas pdData
       let newFormData= {
        "addressId": 6,
        "customerId": 6,
        "name": "alen beta",
        "fname": "alen",
        "lname": "beta",
        "phone": "5121231234",
        "email": "alen11@br.com",
        "login": "alenb",
        "password": null,
        "otherDetails": "need pickup",
        "city": "san jose",
        "state": "ca",
        "country": "usa",
        "address": null,
        "zipcode": "95123",
        "isdcode": "1",
        "addressType": "B",
        "createdDate": null,
        "modifiedDate": null,
        "createdBy": null,
        "modifiedBy": null
    }
        this.props.load(newFormData)
       
        
     }
     */
 loadGene(e){
        console.log(e)
    }

    dcountryChange(e){

        console.log(e)
        console.log('gene name:' +this.props.dcountry)

        let o = _.find(dcountries,{value:e.target.value})
        console.log(o)
        this.props.load({
            id:o.value,
             dcountry:o.name
        })

    }
    
    ddChange(e){
        
        console.log(e)
        console.log('gene name:' +this.props.gene)

        let o = _.findWhere(genes,{value:e.target.value})
        console.log(o)
        this.props.load({
            id:o.value,
             gene:o.name
        })
        //load geneBus Componnet initialValues and form will reinitalize

    }
    
    render(){
        console.log('sv... SVCDnaStepFormBus')
        const { handleSubmit, pristine, error,reset, submitting } = this.props
        const { load, initialValues } = this.props
        //const { initialValues,load, handleSubmit,loadGeneTemplate,  pristine, reset, submitting, submit, startSubmit } = this.props 
       //we are copying all members from initialValues and senfint to props
       /* const {initialValues} = this.props
       

        */
        const {  isdcode, email} = this.props
        console.log( isdcode)
        console.log( email)
        console.log( isdcode)
        console.log(initialValues)
       // const { id, gene, email} = initialValues

        const me = this 
        //me.gene = gene

        console.log(this.props)

        return (
            <div>
             
            <form  onSubmit={handleSubmit}>
            <div className="rev-row">
             <div className="card card--raised with-shadow">
                <p className="right-sd-content"> <text> Enter Details Now </text></p>

                    <div className="form-group">
                            <label htmlFor="id"> ID</label>
                            
                                <Field
                            
                                id="id"
                                    name="id"
                                    type="text"
                                    placeholder="id"
                                    component="input"
                                    className="form-control"
                                />
                            

                        </div>
                    <div className="form-group">
                            <label htmlFor="fname"> First Name</label>
                            
                                <Field
                            
                                    id="fname"
                                    name="fname"
                                    type="text"
                                    placeholder="John"
                                    component={renderField}
                                    className="form-control"
                                />
                        </div>
                        <div className="form-group">
                            <label htmlFor="lname"> Last Name</label>
                            <Field
                                    id="lname"
                                    name="lname"
                                    type="text"
                                    placeholder="Glen"
                                    component={renderField}
                                    className="form-control"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email"> Email Address</label>
                            <Field
                                    id="email"
                                    name="email"
                                    type="text"
                                    placeholder="john123@yahoo.com"
                                    component="input"
                                    className="form-control"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="address"> Address </label>
                            <Field
                                    id="address"
                                    name="address"
                                    type="text"
                                    placeholder="790 J St, Lincoln"
                                    component={renderField}
                                    className="form-control"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="city"> City</label>
                            <Field
                                    id="city"
                                    name="city"
                                    type="text"
                                    placeholder="Lincoln"
                                    component={renderField}
                                    className="form-control"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="gene"> Zip Code</label>
                            <Field
                                    id="zip"
                                    name="zip"
                                    type="text"
                                    placeholder="95648"
                                    component={renderField}
                                    className="form-control"
                            />
                        </div>
                        <div class="form-group">
                        
                        <label htmlFor="dcountry">Country </label>
                        <Field id="dcountry"  name="dcountry" onChange={me.dcountryChange} component="select">

                            <option  value="">Select Country</option>
                            {
                                dcountries.map ((o, idx)=>{

                                    return ( <option  value={o.value}>{o.name}</option>)
                                })
                            }

                        </Field>

                        </div>
                        <div className="form-group">
                            <label htmlFor="isdcode"> ISD Code</label>
                            <Field
                                    id="isdcode"
                                    name="isdcode"
                                    type="text"
                                    placeholder="+1"
                                    component="input"
                                    className="form-control"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="phone"> Phone</label>
                            <Field
                                    id="phone"
                                    name="phone"
                                    type="text"
                                    placeholder="916-645-6360"
                                    component={renderField}
                                    className="form-control"
                            />
                        </div>
                    
               

                {/*   
                <div className="form-group">
                   
                    <label className="svradio-item-label-bl">
                        <Field name="bookingAgentType" component="input" type="radio" value="self" />{' '}
                        Self
                    </label>
                    <label className="svradio-item-label-bl">
                        <Field name="bookingAgentType" component="input" type="radio" value="others" />{' '}
                        Others
                    </label>
    
                </div>
                */}
                {/* 
                <div className="form-group">
                    <label htmlFor="bookingAgentType">Who are you booking for?</label>

                        <Field
                        name="bookingAgentType"
                        component={renderSelectList}
                        data={['Self', 'Others']}
                        />
                </div>
                */}
               
                {/*  
                <div className="form-group">
                     <label htmlFor="specialRequests"> Special Requests</label>
                    <Field
                            id="specialRequests"
                            name="specialRequests"
                            type="text"
                            placeholder="Wheel chair and Senior Citizen"
                            component="textarea"
                            className="form-control"
                    />
                </div>
                <div className="form-group">
                     <label htmlFor="card">  Credit Card Number</label>
                    <Field
                            id="card"
                            name="card"
                            type="text"
                            placeholder="1234-1234--1234--1234"
                            component={renderField}
                            className="form-control"
                    />
                </div>
                <div className="form-group">
                     <label htmlFor="gene">  Card CVV/CVV2</label>
                    <Field
                            id="cvv"
                            name="cvv"
                            type="text"
                            placeholder="123"
                            component={renderField}
                            className="form-control"
                    />
                </div>
                <div className="form-group">
                     <label htmlFor="mmexp">  Card Expiration Date Month</label>
                    <Field
                            id="mmexp"
                            name="mmexp"
                            type="text"
                            placeholder="02"
                            component={renderField}
                            className="form-control"
                    />
                </div>
                <div className="form-group">
                     <label htmlFor="yyyyexp">  Card Expiration Date Year</label>
                    <Field
                            id="yyyyexp"
                            name="yyyyexp"
                            type="text"
                            placeholder="2028"
                            component={renderField}
                            className="form-control"
                    />
                </div>
                
                <div class="form-group">
                  
                  <label htmlFor="gene">BusSlot </label>
                  <Field id="gene"  name="gene" onChange={me.ddChange} component="select">

                    <option  value="">Select DNA</option>
                    {
                        genes.map ((o, idx)=>{

                            return ( <option  value={o.value}>{o.name}</option>)
                        })
                    }

                  </Field>

                </div>

                */}

               <div>
            </div>
            </div>
         </div>
            
            <div className="rev-row">
                    <div className="card card--raised with-shadow">
                        <p className="right-sd-content"> <text> Additional Travel Information </text></p>
                        <div className="form-group">
                            <label htmlFor="bookingAgentType">Who are you booking for?</label>

                                <Field
                                name="bookingAgentType"
                                component={renderBookingAgentType}
                                data={['selfTravel', 'others']}
                                />
                        </div>
                        <div>
                        <label htmlFor="radiogroupba">RG</label>
                        <Radio.Group name="radiogroupba" defaultValue={1}>
                            <Radio value={1}>A</Radio>
                            <Radio value={2}>B</Radio>
                            <Radio value={3}>C</Radio>
                            <Radio value={4}>D</Radio>
                         </Radio.Group>
                        </div>
                        <div className="form-group">
                            <label htmlFor="traveType">Business Travel ?</label>

                                <Field
                                name="traveType"
                                component={renderTravelSelectList}
                                data={['Business', 'Personal']}
                                />
                        </div>
                    </div>
            </div>
            
            <div className="rev-row">
              <div className="card card--raised with-shadow">
                 <p className="right-sd-content"> <text> Guest Details </text></p>

                 <div className="form-group">
                     <label htmlFor="gname"> Full Guest Name</label>
                    <Field
                            id="gname"
                            name="gname"
                            type="text"
                            placeholder="jenny"
                            component="input"
                            className="form-control"
                    />
                </div>
                <div className="form-group">
                     <label htmlFor="gemail">  Guest Email</label>
                    <Field
                            id="gemail"
                            name="gemail"
                            type="text"
                            placeholder="jenny@yahoo.com"
                            component="input"
                            className="form-control"
                    />
                </div>
            </div>
        
        <button type="submit" className="btn btn-success" disabled={pristine || error || submitting}>
               Next -  Payment Details
        </button>   
        <button type="button" className="btn btn-success" onClick={this.props.previousPage}>
          Previous - Space Details
        </button>
        <button type="button" onClick={() => load(data)}>
          Load Account
        </button>
        
        </div>
               

            
            </form>
         </div>
        )
    }

}

const pdForm = reduxForm({

    form:SVPDFORM,
    validate:validate,
    //asyncValidate: asyncValidate,
    warn:warn,
    //onSubmit:svsubmit,
    onChange:svChange,
    enableReinitialize:true,
    keepDirtyOnReinitialize:true

})(PaymentDetailFormBus)

const selector = formValueSelector(SVPDFORM)



let PaymentDetailFormBusCom =connect((state=>{
    //we are not using key nmae intiailValues rathre returning flat content ky/valu as pdData
    //reducForm provideis built in load - we have tp provide our action here  then our form component can call load from props
    //we cannot mofifiy initial Valy=ues or statehere only in reducers
//we have action loadAddressData from reviewaction that modiefied pdData in TaskReducer. the address data is stored in this form. we will add card data also in pdData
    let plucked = state.movies
    console.log('sv***PaymentDetails taskreducers')
    console.log(plucked)
    let custProfile = state.reviewView.custProfile
    let my_data_address = state.reviewView.my_data_address
    let my_data_card = state.reviewView.my_data_card
    let o = {initialValues:plucked.pdData ,"my_data_card":my_data_card,"my_data_address":my_data_address, "custProfile":custProfile}
    selector(state, 'id')
    console.log('sv info')
    console.log(o)
     
    //return plucked.pdData
    return o
}),{
    //load:loadPdMyReservatiionsAddressAction,
    load:loadAccount,
    
    startSubmit:startSubmit
   
   // loadGeneTemplate:loadGeneTemplate

    
})(pdForm)





export default PaymentDetailFormBusCom